import { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import colors from "../../utils/style/colors.tsx";
import { Titre, Texte } from "../../utils/style/elements.tsx";
import { useLocation } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import FR from "../../assets/images/fr.png";
import GB from "../../assets/images/gb.png";
import headerTrad from "../../traductions/header-trad.js";

const MenuWrapper = styled.header`
    background-color: ${colors.black};
    color: ${colors.white} !important;
    display: flex;
    justify-content: space-between;
`;

const NavWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: column;
`;

const NavTitleWrapper = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;
    width: 100%;
`;

const StyledTitle = styled(Titre)`
    text-align: center;

    .desktop-dash {
        display: inline;
    }

    .mobile-break {
        display: none;
    }

    @media (max-width: 768px) {
        .desktop-dash {
            display: none;
        }

        .mobile-break {
            display: inline;
        }
    }
`;

const StyledTexte = styled(Texte)`
    margin-bottom: 25px;
    margin-top: 0;

    @media (max-width: 768px) {
        margin-bottom: 15px;
    }
`;


const NavLinkWrapper = styled.nav`
    display: flex;
    gap: 60px;
    justify-content: center;
    width: 100%;

    @media (max-width: 768px) {
        gap: 40px;
    }
`;

const DivWrapperButtonLang = styled.div`
    width: fit-content;
    position: absolute;
    right: 70px;
    top: 115px;
    display: flex;

    button{
        border: 0;
        background-color: ${colors.red};
        font-size: 34px;
        padding: 0px 10px;
        cursor: pointer;
        height: 40px;
        display: flex;

        &:hover{
            background-color: ${colors.red};
        }
    }

    @media (max-width: 1000px) {
        top: 148px;
    }

    @media (max-width: 768px) {
        right: 40px;
        top: 40px;

        button{
            height: 19px;
            padding: 1px 4px;
        }
    }
`;

const FrenchButton = styled.button`
    opacity: ${({ language }) => (language === "fr" ? "1" : "0.5")};
    // filter: ${({ language }) => (language === "fr" ? "none" : "grayscale(100%)")};
    transition: opacity 0.3s ease, filter 0.3s ease;
`;

const EnglishButton = styled.button`
    opacity: ${({ language }) => (language === "en" ? "1" : "0.5")};
    // filter: ${({ language }) => (language === "en" ? "none" : "grayscale(100%)")};
    transition: opacity 0.3s ease, filter 0.3s ease;
`;

const ImgButton = styled.img`
    width: 40px;
    height: auto;

    @media (max-width: 768px) {
        width: 18px;
    }
`


const StyledLink = styled(Link)`
    color: ${colors.white};
    text-decoration: none;
    display: flex;
    border-bottom: none;

    &.active {
        border-bottom: solid 1px ${colors.white};
        padding-bottom: 4px;
    }
`;


function Header() {
    const location = useLocation();
    
    const { language, setLanguage } = useContext(LanguageContext);

    const setFrench = () => setLanguage("fr");
    const setEnglish = () => setLanguage("en");

    return (
        <MenuWrapper>
            <NavWrapper>
                <NavTitleWrapper>
                    <StyledTitle>
                            Portfolio <span className="mobile-break"><br /></span> 
                            <span className="desktop-dash"> - </span>Alexandre Kotowicz
                    </StyledTitle>
                </NavTitleWrapper>
                <NavLinkWrapper>
                    <StyledTexte>
                        <StyledLink to="/" className={location.pathname === "/" ? "active" : ""}>
                            {headerTrad[language].projects}
                        </StyledLink>
                    </StyledTexte>
                    <StyledTexte>
                        <StyledLink to="/bio" className={location.pathname === "/bio" ? "active" : ""}>
                            {headerTrad[language].bio}
                        </StyledLink>
                    </StyledTexte>
                    <StyledTexte>
                        <StyledLink to="/contact" className={location.pathname === "/contact" ? "active" : ""}>
                            {headerTrad[language].contact}
                        </StyledLink>
                    </StyledTexte>
                </NavLinkWrapper>
                
                <DivWrapperButtonLang>
                    <FrenchButton language={language} onClick={setFrench}>
                        <ImgButton src={FR} alt="FR" />
                    </FrenchButton>           
                    <EnglishButton language={language} onClick={setEnglish}>
                        <ImgButton src={GB} alt="GB" />    
                    </EnglishButton>                     
                </DivWrapperButtonLang>    
            </NavWrapper>
        </MenuWrapper>
    );
}

export default Header;
